<template>
  <div class="slide-container">
    <div class="list-wrapper hide-scrollbar">
      <div class="list-content" ref="listContent">
        <slider
          ref="slider"
          @init="init"
          @slide="slide"

          :options="{
            ...options,
            infinite: showCount,
            slidesToScroll: showCount,
          }">
          <!-- slideritem wrapped package with the components you need -->
          <slideritem
            v-for="(item, index) in list"
            class="list-item"
            :style="getItemStyle(index)"
            :key="index"
            >
            <slot :item="item" :index="index">
              {{ item }}
            </slot>
          </slideritem>
          <!-- Customizable loading -->
          <div slot="loading">loading...</div>
        </slider>
      </div>
    </div>
  </div>
</template>

<script>
import { slider, slideritem } from 'vue-concise-slider'
export default {
  components: {
    slider,
    slideritem,
  },
  props: {
    // 显示的个数
    showCount: {
      type: Number,
      default: 3,
    },
    // 列表数据
    list: {
      type: Array,
      default: () => [],
    },
    // 露出的宽度
    peekWidth: {
      type: Number,
      default: 2,
    },
    // 项目间距
    gap: {
      type: Number,
      default: 2,
    },
    // 是否是幸运游戏
    isLucky: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      currentIndex: 0,
      // 添加触摸相关的状态
      options: {
       currentPage: 0,
       tracking: false,
       thresholdDistance: 100,
       thresholdTime: 300,
       infinite: 4,
       slidesToScroll: 4,
       loop: false,
       pagination: false,
     }
    };
  },

  computed: {
    // 计算每个项目的宽度
    itemWidth() {
      const totalGapWidth = this.showCount * this.gap; // 包括最后一个间距
      const availableWidth = 100 - totalGapWidth; // 只减去间距总和
      return this.isLucky ? 65 : availableWidth / this.showCount;
    },

    // 计算最大索引
    maxIndex() {
      return Math.max(0, (Math.ceil(this.list.length / this.showCount) - 1));
    },

    // 是否可以切换到上一页
    canPrev() {
      return this.currentIndex > 0;
    },

    // 是否可以切换到下一页
    canNext() {
      // 总页数
      const totalPages = Math.ceil(this.list.length / this.showCount);
      // 当前页数(从1开始)
      const currentPage = Math.floor(this.currentIndex / this.showCount) + 1;
      
      return currentPage < totalPages;
    },

    // 计算剩余页数
    remainingPages() {
      const totalPages = Math.ceil(this.list.length / this.showCount);
      const currentPage = Math.floor(this.currentIndex / this.showCount) + 1;
      return totalPages - currentPage;
    }
  },

  watch: {
    // 监听状态变化并触发事件
    canPrev(newVal) {
      this.$emit("update:canPrev", newVal);
    },
    canNext(newVal) {
      this.$emit("update:canNext", newVal);
    },
  },

  methods: {
    // 暴露给外部的上一页方法
    prev() {
      this.$refs.slider.$emit('slidePre')
    },

    // 暴露给外部的下一页方法
    next() {
      this.$refs.slider.$emit('slideNext')
    },

    // 获取每个项目的样式
    getItemStyle(index) {
      return {
        flex: `0 0 ${this.itemWidth}%`,
        marginRight: `${this.gap}%`,
      };
    },

    slide(data) {
      this.currentIndex = data.currentPage;
      if(this.canNext && this.remainingPages === 1){
        this.$emit('loadMore')
      }
    },

    init(data) {
      this.currentIndex = data.currentPage || 0;
    }

  },
};
</script>

<style lang="scss" scoped>
.slide-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  margin-top: 10px;
}

.list-wrapper {
  position: relative;
  /* 改为visible，允许内容溢出显示 */
  overflow: visible;
  /* 居中显示 */
  margin: 0 auto;
  /* 调整为98%，留出2%预览空间 */
  width: calc(98% - 10px); /* 总宽度减去左边距 */
  margin-left: 10px;
}

.list-content {
  position: relative;
  display: flex;
  left: 0%;
  width: auto;
  /* 让内容自然延伸 */
  ::v-deep .slider-container{
    overflow: visible;
  }
}

.list-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.prev-btn,
.next-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  padding: 10px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  cursor: pointer;
  border-radius: 50%;
}

.prev-btn {
  left: 10px;
}

.next-btn {
  right: 10px;
}

.hide-scrollbar {
  /* IE, Edge 和 Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;     /* Firefox */
  
  /* Chrome, Safari 和 Opera */
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>